import type {ReactNode} from 'react';

// One responsive room structure: stacked on small screens; stage left and
// cards/actions right on desktop. Purchase dialogs use the same geometry.
export function RoomColumns({stage,children}:{stage:ReactNode;children:ReactNode}){
 return <div className="room-main"><div className="room-stage-column">{stage}</div><div className="room-play-column">{children}</div></div>;
}
